module.exports = __webpack_public_path__ + "img/rv-cover-icon.93edac69.png";